// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductsAnalyticsRow_wrapper__deVDx"};